Property_search_lastminutedeals = {
	init : function(){
		
		// Check if we have LMD elements.
		var lmd_active = Property_search_lastminutedeals.is_active();
		if( !lmd_active )
		{
			return(false);
		}
		
		// Initialise the required UI.
		Property_search_lastminutedeals.init_ui();
	}
	,
	init_ui : function()
	{
		// Determine LMD default dates.
		//var arrival = moment().format('d M yy'); // Today.
		//var departure = moment().add(14,'days').format('YYYY-MM-DD'); // 14 days from Today.
		// Get the values from the date fields.
		var arrival = jQuery('#arrival').val();
		var departure = jQuery('#departure').val();
		
		//jQuery('#arrival')
		//jQuery('#departure')
		//var date_field = search_form.find('input[name="departure"]');
		//date_field.datepicker('option','minDate', selected);
		
		///jQuery('#arrival').datepicker('setDate', '+0d');
		///jQuery('#departure').datepicker('setDate', '+14d');
		
		//jQuery('#last-minute-specials-search').submit();
		
		//Property_search_lastminutedeals.check_form();
	}
	,
	check_form : function()
	{
		// Check if search is empty.
		if( Property_search_lastminutedeals.is_empty() )
		{
			jQuery('#arrival').datepicker('setDate', '+2d');
			jQuery('#departure').datepicker('setDate', '+14d');
			
			jQuery('#last-minute-specials-search').submit();
		}
	}
	,
	is_empty : function()
	{
		// Get the values from the date fields.
		var arrival = jQuery('#arrival').val();
		var departure = jQuery('#departure').val();
		
		var empty = (arrival == '' && departure == '');
		
		return(empty);
	}
	,
	is_active : function()
	{
		return( jQuery('#last-minute-specials-search').length > 0 );
	}
}

jQuery(document).ready(function(jQuery){
	
	// Decided not to do the form reload in JavaScript - creates double page load.
	//Property_search_lastminutedeals.init();

});

//?view=grid&special_id=&property_id=&suburb=&arrival=9+Jun+2023&departure=14+Jun+2023&sleeps_min=&building_type=&keyword_search=&search_price_type=nightly&property_site_id=&sort=price&order=desc&properties_per_page=20&sort_combo=
//?arrival=7+Jun+2023&departure=14+Jun+2023
